import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=bddcd07a&scoped=true&"
import script from "./Queue.vue?vue&type=script&lang=js&"
export * from "./Queue.vue?vue&type=script&lang=js&"
import style0 from "./Queue.vue?vue&type=style&index=0&id=bddcd07a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddcd07a",
  null
  
)

export default component.exports